




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';

/**
 * Components
 */
import LabelDashboard from './components/Label.vue';

/**
 * API
 */
import transactionsAPI from '@/api/transactions';
import bookingsAPI, { BookingCategory } from '@/api/bookings';
import { SettingsResponseModel } from '@/api/settings';

/**
 * Types
 */
import { sortByDate } from '@/utils/date-helpers';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');

/**
 * Page du dashboard usager.
 */
@Component({
	components: {
		'label-dashboard': LabelDashboard
	}
})
export default class DashboardPage extends Vue {
	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** Attributs */
	cards = [
		// {
		// 	title: 'dashboard.transactions_pending',
		// 	icon: '',
		// 	linkLabel: 'dashboard.see_transactions',
		// 	link: '/accounts/transactions',
		// 	apiCall: async () => await transactionsAPI.getAllPending(),
		// 	enabled: (settings: SettingsResponseModel) => settings.payment.enableAccountsConsultation,
		// 	flex: 3
		// },
		{
			title: 'dashboard.bookings_upcoming',
			icon: '',
			linkLabel: 'dashboard.see_bookings',
			link: '/booking',
			apiCall: async () => await bookingsAPI.getAllUpcoming(BookingCategory.PASSAGES),
			enabled: (settings: SettingsResponseModel) => settings.booking.enableBooking,
			flex: 4
		},
		{
			title: 'dashboard.bookings_shop_upcoming',
			icon: '',
			linkLabel: 'dashboard.see_bookings',
			link: '/booking_shop',
			apiCall: async () => await bookingsAPI.getAllUpcoming(BookingCategory.SHOP),
			enabled: (settings: SettingsResponseModel) => settings.bookingShop.enable,
			flex: 4
		},
		{
			title: 'dashboard.bookings_resources_upcoming',
			icon: '',
			linkLabel: 'dashboard.see_bookings',
			link: '/booking_resources',
			apiCall: async () => await bookingsAPI.getAllUpcoming(BookingCategory.RESOURCES),
			enabled: (settings: SettingsResponseModel) => settings.bookingResources.enable,
			flex: 4
		},
		// {
		// 	title: 'dashboard.unbookings_upcoming',
		// 	icon: '',
		// 	linkLabel: 'dashboard.see_bookings',
		// 	link: '/booking',
		// 	apiCall: async () => await bookingsAPI.getAllUnbookingsUpcoming(),
		// 	enabled: (settings: SettingsResponseModel) => settings.booking.enableUnbooking,
		// 	flex: 3
		// }
	];
}
